<template>
  <div class="l-game-root">
    <iframe
      ref="iframe"
      class="l-game-content"
      :src="iframeSrc"
      frameborder='0'>
    </iframe>
  </div>
</template>

<script>
import elementTypes from '../../minxin/elementTypes'
import { createNamespacedHelpers } from 'vuex'
import UPModel from '@/models/imgup'

const up = new UPModel()
const { mapGetters, mapActions } = createNamespacedHelpers('course')
const MessageType = {
  MOUNTED: 'mounted',
  START: 'start',
  END: 'end',
}

export default {
  mixins: [elementTypes],
  data() {
    return {
      sourceDomain: '',
      iframeSrc: `${process.env.VUE_APP_SPELLWORLD_URL}/?origin=${window.location.origin}`
    }
  },
  computed: {
    ...mapGetters(['element']),
    attrs() {
      if (!this.element) return {}
      return this.element.attrs || {}
    },
    gameWords() {
      if (!this.attrs.words) return []
      const data = this.attrs.words.map(item => {
        const cut = this.convertStringToArray(item.cut)
        return { ...item, cut, }
      })
      const groupedData = {};
      data.forEach(item => {
        if (!groupedData[item.group]) {
          groupedData[item.group] = [];
        }
        groupedData[item.group].push(item);
      });
      return Object.values(groupedData);
    },
    gameData() {
      return {
        data: this.gameWords,
        description: this.attrs.description,
        bonus: 0,
        passed: 0,
        cost: null,
        lv: "",
        sourceDomain: this.sourceDomain,
      }
    },
  },
  watch: {
    attrs(newVal) {
      if (newVal.words && newVal.words.length) {
        this.getAudioUrl(newVal.words[0].sound)
      }
    }
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    async getAudioUrl(paths) {
      const res = await up.resource({ paths: paths })
      const url = res.data[0]
      // 从url中获取域名
      const domain = url.match(/https:\/\/[^/]+/)[0]
      this.sourceDomain = domain
    },
    // "红im/蓝p/红ort" 格式转换成数组[{t: 'im', c: 'red'}, {t: 'p', c: 'blue'}, {t: 'ort', c: 'red'}]
    convertStringToArray(str) {
      const colorsMap = {
        红: 'red',
        蓝: 'blue',
        黑: 'black',
      };
      return str.split('/').map(item => {
        let color =  colorsMap[item.slice(0, 1)];
        let text = item.slice(1);
        return { t: text, c: color };
      });
    },
    handleReceiveMessage(e) {
      const { data } = e

      if (e.origin !== process.env.VUE_APP_SPELLWORLD_URL) return

      if (data.type === MessageType.MOUNTED) {
        this.receiveMountedMessage(e.origin)
      } else if (data.type === MessageType.END) {
        this.receiveEndMessage()
      }
    },
    receiveMountedMessage(origin) {
      this.$refs.iframe.contentWindow.postMessage(
        {
          type: MessageType.START,
          data: this.gameData,
        },
        origin
      )
    },
    receiveEndMessage() {
        this.$emit('submit')
    },
  },
  mounted() {
    window.addEventListener('message', this.handleReceiveMessage, false)
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
